/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function ChangeRequestDraft({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M12 .9c-.232 0-.457.03-.673.088a.6.6 0 1 0 .31 1.16 1.403 1.403 0 0 1 .726 0 .6.6 0 0 0 .31-1.16A2.603 2.603 0 0 0 12 .9ZM14.512 2.827a.6.6 0 0 0-1.16.31 1.405 1.405 0 0 1 0 .726.6.6 0 1 0 1.16.31 2.604 2.604 0 0 0 0-1.346ZM10.647 3.137a.6.6 0 1 0-1.159-.31 2.603 2.603 0 0 0 0 1.346.6.6 0 1 0 1.16-.31 1.405 1.405 0 0 1 0-.726ZM12.673 6.012a.6.6 0 0 0-.31-1.16 1.403 1.403 0 0 1-.726 0 .6.6 0 0 0-.31 1.16 2.603 2.603 0 0 0 1.346 0Z" /><path fill="currentColor" fillRule="evenodd" d="M12.6 8v1.97a2.601 2.601 0 1 1-1.2 0V8a.6.6 0 1 1 1.2 0Zm-2 4.5a1.4 1.4 0 1 1 2.8 0 1.4 1.4 0 0 1-2.8 0ZM4.6 9.97a2.601 2.601 0 1 1-1.2 0V6.03a2.601 2.601 0 1 1 1.2 0v3.94Zm-2 2.53A1.4 1.4 0 0 1 4 11.1s-.001 0 0 0a1.4 1.4 0 1 1-1.4 1.4ZM4 2.1a1.4 1.4 0 1 0 0 2.8 1.4 1.4 0 0 0 0-2.8Z" clipRule="evenodd" /></svg>;
}
;